import {registerCustomHook} from "../lib/core";
import {store} from "../lib/store";
import {CONFIG} from "./config";

//Custom loading hooks
const replaceCheckmark = (obj) => {
	if (typeof obj === 'string') {
		return obj.replace(/✓/g, '<i class="fal fa-check"></i>');
	}
	if (Array.isArray(obj)) {
		return obj.map(item => replaceCheckmark(item));
	}
	if (typeof obj === 'object' && obj !== null) {
		const newObj = {};
		for (const key in obj) {
			newObj[key] = replaceCheckmark(obj[key]);
		}
		return newObj;
	}
	return obj;
};

export const initCustomHooks = () => {
	//registerCustomHook('onNotFoundLoadingPage', (params) => {});
	//registerCustomHook('onBeforeEvaluatingPage', (params) => {});

    registerCustomHook('onBeforeLoadingPage', (params) => {


        if (CONFIG.cachePages > 0 && store.getState().pageState.previous.map(prev => prev.page?.slug).indexOf(params.search) >= 0) {
            let index = store.getState().pageState.previous.map(prev => prev.page?.slug).indexOf(params.search);
            store.dispatch({
                type: 'PAGE_LOADED',
                page: store.getState().pageState.previous[index].page,
                head: store.getState().pageState.previous[index].head
            })
            return false;
        }
        return true;

    });

	registerCustomHook('onSuccessLoadingPage', (params) => {
		if (params.page) {
			if (params.page.fields) {
				params.page.fields = replaceCheckmark(params.page.fields);
			}
			if (params.page.content) {
				params.page.content = params.page.content.replace(/✓/g, '<i class="fal fa-check"></i>');
			}
			if (params.page.title) {
				params.page.title = params.page.title.replace(/✓/g, '<i class="fal fa-check"></i>');
			}
		}
	});

	//registerCustomHook('onSuccessLoadingPage', (params) => {});
	registerCustomHook('onSettingsLoaded', (params) => {
		if (params.rsp) {
			if (params.rsp.footer) {
				params.rsp.footer = replaceCheckmark(params.rsp.footer);
			}
			if (params.rsp.settings) {
				params.rsp.settings = replaceCheckmark(params.rsp.settings);
			}
		}
	});

	//registerCustomHook('onSettingsLoaded', (params) => {});
    //registerCustomHook('onComponentCookieAccept', (accepted) => {});
    //registerCustomHook('modifySearchSlug', (params) => { return true; });
};



